import {
    BulletList,
    Card,
    Exercise,
    LabelBody,
    LabelDisplay1,
    LabelDisplay2,
    ProgressBar,
    SecondaryButton,
    Spacer,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { ExerciseStatus } from '../../interfaces';
import { Module7Exercise1Illustration4 } from '../../icons';

export const exerciseData314: ExerciseData = {
    ExerciseView: Module3Exercise1Part4,
    dataKeys: [],
    questions: [],
};

const numberOfPreviousPages = 10;

function Module3Exercise1Part4({ exercise, onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="Formålsenergi">
            <ProgressBar
                current={exercise.CurrentPage + numberOfPreviousPages}
                total={11}
            />
            <Module7Exercise1Illustration4 className="mx-auto" />
            <LabelDisplay2 className="mt-20">Formålsenergi</LabelDisplay2>
            <LabelBody className="mt-10">
                Selvom vi ikke nævnte det i starten, så er der en top på
                energipyramiden. Den hedder formålsenergi, og er den mest
                abstrakte energitype. Den handler nemlig om, at vores energi
                bliver påvirket af, om vi ser en mening med det, vi er i gang
                med.
            </LabelBody>
            <LabelBody className="mt-10">
                I modul 4 vil vi dykke dybere ned i dine værdier og hjælpe dig
                med at identificere dem. Indtil da kan du reflektere over
                følgende:
            </LabelBody>
            <Card className="my-30">
                <LabelDisplay1>Refleksion</LabelDisplay1>
                <LabelBody className="mt-10">
                    <BulletList
                        items={[
                            'Er der noget i dit liv lige nu, som giver dig en følelse af mening og motiverer dig?',
                            'Hvad betyder noget for dig i det store billede?',
                            'Hvad ønsker du at stå for?',
                        ]}
                    ></BulletList>
                </LabelBody>
            </Card>
            <Spacer className="mt-30" />
            <SecondaryButton
                onClick={() => {
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: '3.1.completed',
                    });
                }}
            >
                Afslut øvelsen
            </SecondaryButton>
        </Exercise>
    );
}
